import { desktop } from './check-res.js'

import gsap from 'gsap'
import SplitText from 'gsap/SplitText'

gsap.registerPlugin(SplitText)

if (desktop) {
	const textHover = document.querySelectorAll('.text-hover')
	new SplitText('.text-hover__elem', {
		type: 'chars, words',
		charsClass: 'char',
	})

	textHover.forEach((text) => {
		let textHover1 = text.querySelectorAll('.text-hover__elem-1 .char')
		let textHover2 = text.querySelectorAll('.text-hover__elem-2 .char')

		const tlTextHover = gsap
			.timeline({
				paused: true,
				defaults: { stagger: 0.015, duration: 0.35, ease: 'power3.easeOut' },
			})
			.to(textHover1, { yPercent: -120 })
			.to(textHover2, { yPercent: -100 }, 0)

		text.addEventListener('mouseenter', function () {
			tlTextHover.play()
		})

		text.addEventListener('mouseleave', function () {
			tlTextHover.reverse()
		})
	})
}
